<div class="actions actions__left">
  <ng-container [ngTemplateOutlet]="tmplActionSection" [ngTemplateOutletContext]="{ actions: $leftSectionActions() }" />
</div>

<div class="actions actions__right">
  <ng-container
    [ngTemplateOutlet]="tmplActionSection"
    [ngTemplateOutletContext]="{ actions: $rightSectionActions() }"
  />
</div>

<ng-template #tmplActionSection let-actions="actions">
  @if (actions.length > 0) {
    @for (action of actions; track trackBy(action)) {
      @if (!action.visible$ || (action.visible$ | async)) {
        <osp-button
          [label]="action.label"
          [category]="action.category"
          [rounded]="action.rounded || false"
          [disabled]="(action.$disabled && action.$disabled()) || false"
          [loading]="(action.$loading && action.$loading()) || false"
          [icon]="action?.icon"
          [iconPos]="action?.iconPos"
          (onClick)="(action.menuOptions || []).length > 0 ? menu.show($event) : action.action()"
          [tooltip]="action.tooltip"
          [tooltipPosition]="action.tooltipPosition"
        />
        <osp-menu #menu class="button-menu" [model]="action.menuOptions" [popup]="true" />
      }
    }
  }
</ng-template>
